<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Title</label>
          <div class="p-col">
            <InputText id="name" class="" v-model="obj_data.name" placeholder="Input (max: 255 characters)"
              @input="limitText('name', 255)" />
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Promo code</label>
          <div class="p-col">
            <InputText :disabled="mode==='edit'" id="code" class="" v-model="obj_data.code"
              placeholder="Input (max: 20 characters)" @input="limitText('code', 20)" />
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Short description</label>
          <div class="p-col">
            <Textarea id="short_description" class="" v-model="obj_data.short_description"
              placeholder="Input (max: 500 characters)" @input="limitText('short_description', 500)">
    </Textarea>
          </div>
        </div>


      </div>

      <div class="col-12 style_title_group_car_infomation"></div>

      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">CONDITIONS</label>
          <div class="p-col"></div>
        </div>

        <div class="p-card-field">
          <div class="p-col">
            <!-- RadioButton: All services -->
            <div class="p-field-radiobutton">
              <RadioButton v-model="obj_data.type_condition" inputId="all_services" value="1"
                :disabled="shouldDisableRadio(1)" />
              <label for="all_services" class="css_voucher1">All services</label>
            </div>

            <!-- RadioButton: Rent -->
            <div class="p-field-radiobutton">
              <RadioButton v-model="obj_data.type_condition" inputId="rent" value="2"
                :disabled="shouldDisableRadio(2)" />
              <label for="rent" class="css_voucher1">Rent</label>
            </div>

            <!-- RadioButton: Buy -->
            <div class="p-field-radiobutton">
              <RadioButton v-model="obj_data.type_condition" inputId="buy" value="3"
                :disabled="shouldDisableRadio(3)" />
              <label for="buy" class="css_voucher1">Buy</label>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6" v-if="obj_data.type_condition == 2">
        <div class=" p-card-field">
          <label class="p-col-fixed txt-right">Durantion of the term from</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber v-model="obj_data.duration" :min="0" id="duration" placeholder="0 (if 0, no limit)" />
              <span class="p-inputgroup-addon">days</span>
            </div>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Based on vehicle category</label>
          <div class="p-col">
            <!-- MultiSelect Dropdown -->
            <MultiSelect :clearable="false" title="Service" placeholder="Choose" v-model="selectedVehicleCategory"
              @change="onCategoryChange" :options="listVehicleCategory" option-label="name">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </MultiSelect>

            <!-- Hiển thị các mục đã chọn dưới dropdown -->
            <div class="selected-items">
              <div v-for="(item, index) in selectedVehicleCategory" :key="index" class="selected-item">
                <span>{{ item.name }}</span>
                <button type="button" @click="removeVehicleCategory(item)" class="remove-button"><i
                    class="fas fa-times"></i></button>
              </div>
            </div>

            <input class="input_tmp_validator" id="selectedVehicleCategory">
          </div>
        </div>


      </div>
      <div class="col-6">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.limit_use" :binary="true" />
            <label class="p-col-fixed txt-right text">Limit to one use per customer.</label>
          </div>
        </div>
      </div>

      <div class="col-12 style_title_group_car_infomation"></div>

      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">VALIDITY</label>
          <div class="p-col">
          </div>
        </div>

        <div class="p-card-field">
          <div class="row">
            <div class="col-6">
              <label class="p-col-fixed txt-right">Start</label>
              <div class="p-col">
                <Calendar :showOnFocus="false" dateFormat="dd/mm/yy" :showIcon="true" appendTo="self" :showClear="true"
                  :manualInput="false" v-model="obj_data.valid_start" placeholder="DD/MM/YYYY" />
                <input class="input_tmp_validator" id="valid_start" />
              </div>
            </div>

            <div class="col-6">
              <label class="p-col-fixed txt-right">End</label>
              <div class="p-col">
                <Calendar :showOnFocus="false" dateFormat="dd/mm/yy" :showIcon="true" appendTo="self" :showClear="true"
                  :manualInput="false" v-model="obj_data.valid_end" placeholder="DD/MM/YYYY" />
                <input class="input_tmp_validator" id="valid_end" />
              </div>
            </div>
            <div class="col-6">
              <div class=" p-card-field">
                <label class="p-col-fixed txt-right">Validity duration</label>
                <div class="p-col">
                  <div class="p-inputgroup">
                    <InputNumber v-model="obj_data.valid_duration" :min="0" id="valid_duration"
                      placeholder="0 (if 0, infinite use)" />
                    <span class="p-inputgroup-addon">days</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="col-12 style_title_group_car_infomation"></div>

      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">REWARDS</label>
          <div class="p-col">
          </div>
        </div>

        <div class="p-card-field">
          <div class="row">
            <div class="col-6 ">
              <label class="p-col-fixed txt-right txt-required">Apply discount</label>
              <div class="p-col">
              
                <Dropdown :disabled="mode== 'edit'" :clearable="false" title="Service" placeholder="Choose" v-model="selectedtypeDiscount"
                  :options="optionTypeDiscount" option-label="name">
                  <span slot="no-options" @click="$refs.select.open = false">
                    Empty data
                  </span>
                </Dropdown>

                <input class="input_tmp_validator" id="type_discount" />
              </div>
            </div>




            <div class="col-6 ">
              <label class="p-col-fixed txt-right txt-required">Amount</label>
              <div class="p-col">
                <div class="p-inputgroup">
                  <InputNumber v-model="obj_data.amount" :min="0" id="amount" placeholder="0 (if 0, no limit)"
                    :minFractionDigits="2" :maxFractionDigits="2" />
                  <template v-if="selectedtypeDiscount.id == 1">
                    <span class="p-inputgroup-addon">%</span>
                  </template>
                  <template v-else>
                    <span class="p-inputgroup-addon">$</span>
                  </template>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-6" v-if="selectedtypeDiscount.id == 1">
        <div class=" p-card-field">
          <label class="p-col-fixed txt-right ">Max discount amount</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber v-model="obj_data.max_discount_amount" :min="0" id="max_discount_amount"
                :minFractionDigits="2" :maxFractionDigits="2" placeholder="0 (if 0, no limit)" />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 style_title_group_car_infomation"></div>

      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">FOR CUSTOMERS</label>
          <div class="p-col"></div>
        </div>

        <!-- InputText hiển thị khi mode === 'edit' và type_apply_customer === 3 -->
        <div class="p-card-field"
          v-if="mode === 'edit' && obj_data.type_apply_customer == 3 && listVoucherCustomer.length > 0">
          <div class="p-col">
            <InputText id="name" class="" placeholder="Customers" :disabled="true" />
          </div>
        </div>

        <!-- Các radio button -->
        <div class="p-card-field"
          v-if="!(mode === 'edit' && obj_data.type_apply_customer == 3 && listVoucherCustomer.length > 0)">
          <div class="p-col">
            <!-- RadioButton: All customers -->
            <div class="p-field-radiobutton">
              <RadioButton v-model="obj_data.type_apply_customer" inputId="all_services" value="1"
                :disabled="shouldDisableRadioCustomer(1)" />
              <label for="all_services" class="css_voucher1">All customers</label>
            </div>

            <!-- RadioButton: Loyalty level -->
            <div class="p-field-radiobutton">
              <RadioButton v-model="obj_data.type_apply_customer" inputId="rent" value="2"
                :disabled="shouldDisableRadioCustomer(2)" />
              <label for="rent" class="css_voucher1">Loyalty level</label>
            </div>

            <!-- MultiSelect hiển thị khi type_apply_customer === 2 -->
            <div class="col-12" v-if="obj_data.type_apply_customer == 2">
              <label class="p-col-fixed txt-right">Based on loyalty level</label>
              <div class="p-col">
                <MultiSelect :clearable="false" title="Service" placeholder="Choose" v-model="selectedLoyalty"
                  :options="listLoyaltyLevel" option-label="level">
                  <span slot="no-options" @click="$refs.select.open = false">
                    Empty data
                  </span>
                </MultiSelect>

                <input class="input_tmp_validator" id="selectedLoyalty" />
              </div>
            </div>

            <!-- RadioButton: Customers -->
            <div class="p-field-radiobutton">
              <RadioButton v-model="obj_data.type_apply_customer" inputId="buy" value="3"
                :disabled="shouldDisableRadioCustomer(3)" />
              <label for="buy" class="css_voucher1">Customers</label>
            </div>
          </div>
        </div>
      </div>



      <div class="col-6" v-if="obj_data.type_apply_customer == 3">
        <div class="p-card-field p-0">
          <label class="p-col-fixed txt-right p-0 m-0">User</label>
          <div class="d-flex align-items-center">
            <div class="p-col new-select" style="flex-grow: 1;">
              <MultiSelect  :multiple="true" :clearable="false" @search="searchAdmin" placeholder="Choose"
                v-model="selectedUserAppyVoucher" :options="listAdmin"  option-label="fullname" >
                <span slot="no-options" @click="$refs.select.open = false" display="chip" :filter="true">
                  Empty data
                </span>
              </MultiSelect>
              <input class="input_tmp_validator" id="selectedUserAppyVoucher">
            </div>
            <div class="p-col-auto" style="margin-left: 10px;">
              <Button icon="pi pi-plus" class="p-button-success" @click="addUser()" />
            </div>
          </div>
        </div>
      </div>


      <div class="col-12" v-if="obj_data.type_apply_customer == 3">
        <div class="p-card-field">
          <div class="p-col">
            <BaseDatatableUserVoucher v-if="dataModelUselVoucher" :tableData="listDataUserVoucher"
              :model="dataModelUselVoucher" :actions="getRowActions()" v-on:action-click="onActionClicked"
              :dataUser="users"></BaseDatatableUserVoucher>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>

    <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
      Are you want to delete this user ?
      <template #footer>

        <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
        <Button label="Confirm" @click="deleteData()" icon="pi pi-check"
          class="p-button-danger  btn-confirm-delete-dialog" />
      </template>
    </Dialog>
  </form>
</template>
<script>
import DataServices from '@/core/DataServices';
import BaseDatatableUserVoucher from './list_users_voucher'
import moment from 'moment';

export default {
  components: {
    BaseDatatableUserVoucher
  },
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      obj_data: {
        limit_one_use: false,
        active: true,
        type_condition: "1",
        type_apply_customer: "1",
        type_discount: 1,
      },
      vehicleCategories: [],
      // 1.%,2.money
      optionTypeDiscount: [
        { id: 1, name: 'Percentage' },
        { id: 2, name: 'Fixed Amount' }
      ],
      selectedtypeDiscount: { id: 1, name: 'Percentage' },
      users: [],
      selectedUserAppyVoucher: [],
      selectedUserAppyVoucher1: [],
      listAdmin: [],
      listAdminAll: [],
      listDel: [],
      listLoyaltyLevel: [],
      selectedLoyalty: [],
      listVehicleCategory: [],
      selectedVehicleCategory: [],
      dataModelUselVoucher: null,
      listDataUserVoucher: [],
      componentDataUserVoucher: 1,
      listVoucherVehicleCategory: [],
      listVoucherLoyalty: [],
      listVoucherCustomer: [],
      componentKey: 0,
      showDeleteDialog: false,
      deleteId: null,
      filters: {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      countRelationship: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteName: null,
      showConfirmDialog: false,
      whereKeyList: {
        where_key: {
          deleted: { _eq: false }
        },
      },
      page_transaction: null,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      colorArr: [
        '#BBB2F9',
        '#F8D8AB',
        '#BBEFA8',
        '#A7C3FA',
        '#F3B1AF'
      ],
      filterData: {},
      selected: null,
      deleteReason: '',
      idVoucher: null,
      listDelVehicleCategory : [],
    }
  },
  watch: {
    'obj_data.valid_start': 'validateDates',
    'obj_data.valid_end': 'validateDates'
  },
  async mounted() {

    await this.getListAdmin();
    await this.getListLoyaltyLevel();
    await this.getLisVehicleCategory();
    
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.model;
      this.idVoucher = this.$route.params.id
      console.log('this.idVoucheridVoucher', this.idVoucher);

      if (this.obj_data.type_condition === 1) {
        this.obj_data.type_condition = "1"
      } else if (this.obj_data.type_condition === 2) {
        this.obj_data.type_condition = "2"
      } else if (this.obj_data.type_condition === 3) {
        this.obj_data.type_condition = "3"
      }

      if (this.obj_data.type_apply_customer === 1) {
        this.obj_data.type_apply_customer = "1"
      } else if (this.obj_data.type_apply_customer === 2) {
        this.obj_data.type_apply_customer = "2"
      } else if (this.obj_data.type_apply_customer === 3) {
        this.obj_data.type_apply_customer = "3"
      }
      this.obj_data.valid_start = this.formatDate(this.obj_data.valid_start) ?? null;
      this.obj_data.valid_end = this.formatDate(this.obj_data.valid_end) ?? null;
      
      const typeDiscount = this.obj_data.type_discount;
      console.log('optionTypeDiscountoptionTypeDiscount', this.optionTypeDiscount);

      // Tìm đối tượng khớp với type_discount
      this.selectedtypeDiscount = this.optionTypeDiscount.find(option => option.id === typeDiscount);
      console.log('this.selectedtypeDiscountthis.selectedtypeDiscount', this.selectedtypeDiscount);

      this.loadTableUserVoucher()
      await this.getListVoucherVehicleCategory();
      await this.getListVoucherLoyalty();
      this.filterVehicleCategories();
      this.filterVoucherLoyalty()
      await this.getListVoucherCustomer();
      this.componentKey++;
    } else {
      this.obj_data = {
        active: true,
        ordinal: 1,
        type_condition: "1",
        type_apply_customer: "1",
      };
      this.dataModelUselVoucher = DataServices.getModel('voucher_customer');
      this.componentDataUserVoucher++;
      
      this.componentKey++;
    }
  },
  methods: {
    validateDates() {
      let isFormInvalid = false;

      // Kiểm tra nếu cả ngày bắt đầu và kết thúc đều có giá trị
      if (this.obj_data.valid_start && this.obj_data.valid_end) {
        let valid_start = moment(this.obj_data.valid_start, "DD/MM/YYYY").format("YYYY-MM-DD");
        let valid_end = moment(this.obj_data.valid_end, "DD/MM/YYYY").format("YYYY-MM-DD");

        // Kiểm tra nếu ngày bắt đầu không nhỏ hơn ngày kết thúc
        if (valid_start >= valid_end) {
          // Thiết lập lỗi cho trường ngày bắt đầu nếu điều kiện không hợp lệ
          document.getElementById("valid_start").setCustomValidity("Start date must be less than end date");
          isFormInvalid = true;
        } else {
          // Nếu ngày hợp lệ, xóa thông báo lỗi
          document.getElementById("valid_start").setCustomValidity("");
        }
      }

      // Cập nhật trạng thái form
      this.isFormInvalid = isFormInvalid;
    },
    shouldDisableRadio(value) {
      // Nếu đang ở chế độ 'edit', disable các radio khác ngoài radio đang được chọn
      return this.mode === 'edit' && this.obj_data.type_condition !== null && this.obj_data.type_condition !== value;
    },
    shouldDisableRadioCustomer(value) {
      // Nếu đang ở chế độ 'edit', disable các radio khác ngoài radio đang được chọn
      return this.mode === 'edit' && this.obj_data.type_apply_customer !== null && this.obj_data.type_apply_customer !== value;
    },
    validate_text() {
      // giữ lại ký tự chữ và số là 255 ký tự
      this.obj_data.name = this.obj_data.name.replace(/[^a-zA-Z0-9 ]/g, '').substring(0, 255);
    },
    formatDate(dateString) {
      if (!dateString) {
        return null; // Trả về rỗng nếu dateString là null hoặc undefined
      }

      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return null; // Trả về rỗng nếu date không hợp lệ
      }

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    async getListLoyaltyLevel() {
      var where_key = {
        deleted: { _eq: false },
      }
      var list = await this.$CoreService.getListLoyaltyLevel(where_key);
      this.listLoyaltyLevel = list.list;

    },
    async getListVoucherLoyalty() {
      if (!this.idVoucher || this.idVoucher.trim() === "") {
        console.error("Voucher ID is invalid or empty");
        return;
      }

      var where_key = {
        deleted: { _eq: false },
        voucher_id: { _eq: this.idVoucher }
      };
      var list = await this.$CoreService.getListVoucherLoyalty(where_key);
      this.listVoucherLoyalty = list.list;

    },
    filterVoucherLoyalty() {
      if (!this.listLoyaltyLevel || !this.listVoucherLoyalty) return;

      const voucherLoyaltyId = this.listVoucherLoyalty.map(item => item.loyalty_id);

      this.selectedLoyalty = this.listLoyaltyLevel.filter(loyalty =>
        voucherLoyaltyId.includes(loyalty.id)
      );
      console.log('Selected Vehicle Categories:', this.selectedLoyalty);
    },
    async getLisVehicleCategory() {
      var where_key = {
        deleted: { _eq: false },
      }
      var list = await this.$CoreService.getLisVehicleCategory(where_key);
      this.listVehicleCategory = list.list;

    },
    limitText(field, maxLength) {
      if (this.obj_data[field].length > maxLength) {
        this.obj_data[field] = this.obj_data[field].substring(0, maxLength);
      }
    },
    async getListVoucherVehicleCategory() {
      console.log('this.idVoucher', this.idVoucher);

      if (!this.idVoucher || this.idVoucher.trim() === "") {
        console.error("Voucher ID is invalid or empty");
        return;
      }

      var where_key = {
        deleted: { _eq: false },
        voucher_id: { _eq: this.idVoucher }
      };

      try {
        var list = await this.$CoreService.getListVoucherVehicleCategory(where_key);
        this.listVoucherVehicleCategory = list.list;
        console.log('this.listVoucherVehicleCategory', this.listVoucherVehicleCategory);
      } catch (error) {
        console.error("Error fetching voucher vehicle categories:", error);
      }
    },
    async getListVoucherCustomer() {
      if (!this.idVoucher || this.idVoucher.trim() === "") {
        console.error("Voucher ID is invalid or empty");
        return;
      }

      var where_key = {
        deleted: { _eq: false },
        voucher_id: { _eq: this.idVoucher }
      };
      try {
        var list = await this.$CoreService.getListVoucherCustomer(where_key);
        this.listVoucherCustomer = list.list;
        console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', this.listVoucherCustomer.length);
      } catch (error) {
        console.error("Error fetching voucher vehicle categories:", error);
      }
    },
    filterVehicleCategories() {
      if (!this.listVehicleCategory || !this.listVoucherVehicleCategory) return;

      const voucherCategoryIds = this.listVoucherVehicleCategory.map(item => item.vehicle_category_id);

      this.selectedVehicleCategory = this.listVehicleCategory.filter(category =>
        voucherCategoryIds.includes(category.id)
      );
      console.log('Selected Vehicle Categories:', this.selectedVehicleCategory);
    },
    async deleteData() {
      this.showDeleteDialog = false;
      this.listDataUserVoucher = this.listDataUserVoucher.filter(
        item => item.id !== this.deleteId
      );
      this.selectedUserAppyVoucher = this.selectedUserAppyVoucher.filter(
        user => user.id !== this.deleteId
      );

      await this.$apollo.mutate({
        mutation: DataServices.updateData('voucher_customer'),
        variables: {
          'data_update': {
          'status': '4',
          'updated_by': this.$store.getters.user
        },
        'where_key': {
          'id': { '_eq': this.deleteId }
        }
        }
      });

      this.delUser();
      this.loadTableUserVoucher();
    },
    async loadTableUserVoucher() {
      
      
      var stt = 0;

      var listDataUserVoucher = this.listDataUserVoucher;
      console.log('zaaaaaaaaaaaaaaaaaaaaaaa',listDataUserVoucher.length);
      for (let i = 0; i < listDataUserVoucher.length; i++) {
        stt++;
        listDataUserVoucher[i].stt = stt;
        listDataUserVoucher[i].index = i;
        console.log('listDataUserVoucher[i]listDataUserVoucher[i]', listDataUserVoucher[i]);

      }
      this.listDataUserVoucher = listDataUserVoucher
      console.log('listDataUserVoucher:', this.listDataUserVoucher);
      
      this.dataModelUselVoucher = DataServices.getModel('voucher_customer');
      console.log('this.dataModelUselVoucher:', this.dataModelUselVoucher);
      
      this.componentDataUserVoucher++;
    },
    handleChange() {
      console.log(this.obj_data.type_condition);
    },
    backToList() {
      this.$emit('back');
    },
    getRowActions() {
      var actions = {}
      var that = this;
      //if (this.role.add) {
      // actions.header = {name: 'add', icon: 'plus', path: `list-${this.modelName}/add`};
      //}
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        //if (that.role.edit) {
        // buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-${that.modelName}/edit/`};
        //}
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        //if (that.role.delete) {
        if (rowData.status === "Valid") {
          buttons.delete = { name: 'delete', icon: 'trash', key: 'id' }

        }
        //}
        if (that.dataModelUselVoucher.actions) {
          var modelaction = that.dataModelUselVoucher.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    addUser() {
      console.log("this?.selectedUserAppyVoucher", this?.selectedUserAppyVoucher);

      if (Array.isArray(this.selectedUserAppyVoucher) && this.selectedUserAppyVoucher.length > 0) {
        this.selectedUserAppyVoucher.forEach(m => {
          m.is_new = true;
          m.type_discount = this.selectedtypeDiscount?.id ?? null;
          m.amount = this.obj_data.amount ?? null;
          m.expires = this.obj_data.valid_end ?? null;
          this.users.push(m);
        });
        console.log('this.selectedUserAppyVoucher1', this.selectedUserAppyVoucher);
        
        this.getListAdmin(); // Gọi phương thức này để cập nhật danh sách admin (nếu cần)
        this.selectedUserAppyVoucher1 = this.selectedUserAppyVoucher;
        this.selectedUserAppyVoucher = [];
        console.log('this.selectedUserAppyVoucher', this.selectedUserAppyVoucher);
        
        this.loadTableUserVoucher();
        console.log("Danh sách user là: ", this.users);
      } else {
        console.log("Không có user nào được chọn.");
      }
    },

    delUser(index) {
      if (!this.users[index]?.is_new) {
        this.listDel.push(this.users[index])
      }
      this.users.splice(index, 1);
      this.getListAdmin();
      console.log('fffffffffffffffffffffffffff', this.users);

    },
    async getListAdmin() {

      var listUid = [];
      this.users.map(m => listUid.push(m?.id));
      var where_key = {
        deleted: { _eq: false },
        role: { _eq: 'user' },
        is_verify_email: { _eq: true },

      }
      let { data } = await this.$apollo.query({
        query: DataServices.getList('users', { "fields": `id fullname email` }),
        variables: {
          where_key: where_key,
          orderBy: [{ created_at: 'desc' }]
        },
        fetchPolicy: "network-only"
      })
      var list = data[Object.keys(data)];
      var list_assign = [];
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_assign.push({ id: e.id, fullname: e.fullname , email : e.email});
        //}
      }
      this.listAdmin = list_assign;
      this.listAdminAll = list_assign;
    },

    async searchAdmin(search, loading) {
      console.log(loading);
      var listUid = [];
      this.users.map(m => listUid.push(m?.id));
      if (search !== '' && search !== null) {
        var where_key = {
          deleted: { _eq: false },
          role: { _eq: 'user' },
          id: { _nin: listUid },
          _or: {
            fullname: { _iregex: this.$commonFuction.search(search) },
          }
        };
        let { data } = await this.$apollo.query({
          query: DataServices.getList('users', { "fields": `id fullname` }),
          variables: {
            where_key: where_key,
            orderBy: [{ created_at: 'desc' }]
          },
          fetchPolicy: "network-only"
        })
        var list = data[Object.keys(data)];
        var list_assign = [];
        // console.log("list===",list);
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          //if (!e?.booking?.id || (this.selProperty?.id && this.selProperty?.id == e.id)) {
          list_assign.push({ id: e.id, fullname: e.fullname });
          //}
        }
        this.listAdmin = list_assign;
      } else {
        // cosnole.log("dasdasd")
        this.listAdmin = this.listAdminAll;
      }
    },
    onCategoryChange(value) {
      console.log('Đã thay đổi danh sách:', value);
      if (!value || value.length === 0) {
        this.selectedVehicleCategory = [];
      }
    },
    removeVehicleCategory(item) {
      this.selectedVehicleCategory = this.selectedVehicleCategory.filter(category => category.id !== item.id);
      if (this.mode === 'edit') {
        this.listDelVehicleCategory.push(item.id);
      }

    },
    async validateData() {
      this.validationErrors = {};

      // Kiểm tra xem this.obj_data có tồn tại không
      if (!this.obj_data) {
        console.error("obj_data is undefined or null.");
        return true; // Trả về true để dừng việc kiểm tra khi obj_data không tồn tại
      }
     
      // Các trường cần kiểm tra
      const fieldsToValidate = [
        { id: "name", value: this.obj_data.name },
        { id: "code", value: this.obj_data.code },
        { id: "short_description", value: this.obj_data.short_description },
        // { id: "duration", value: this.obj_data.duration },
        { id: "amount", value: this.obj_data.amount },
        { id: "type_discount", value: this.selectedtypeDiscount },
      ];

      let isFormInvalid = false;

      // Kiểm tra từng trường trong fieldsToValidate
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);

        // Kiểm tra xem phần tử HTML có tồn tại không
        if (!inputElement) {
          console.error(`Element with id '${field.id}' not found.`);
          isFormInvalid = true;
          continue; // Bỏ qua nếu không tìm thấy phần tử
        }
      //   if (this.obj_data.type_condition == 2) {
        
      //   if (this.$commonFuction.isEmptyObject(this.selectedVehicleCategory)) {
      //     inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      //     isFormInvalid = true;
      //   }
        
      // }
        if (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT") {
          // Kiểm tra rỗng cho các trường
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          // Kiểm tra giá trị nhỏ hơn giá trị tối thiểu nếu có (minValue)
          else if (field.minValue !== undefined && field.value <= field.minValue) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          // Kiểm tra độ dài tối đa của chuỗi (nếu có maxLength)
          else if (field.maxLength !== undefined && field.value.length > field.maxLength) {
            inputElement.setCustomValidity(`Max length is ${field.maxLength} characters`);
            isFormInvalid = true;
          }
          // Xóa thông báo lỗi nếu hợp lệ
          else {
            inputElement.setCustomValidity("");
          }
        }
      }

      // kiểm tra trùng code trong bảng voucher, mỗi voucher chỉ có duy nhất 1 code không được trùng code với voucher khác.
      if (this.mode === 'add') {
        let where_key = {
          code: { _eq: this.obj_data.code },
          deleted: { _eq: false }
        };
        let { data } = await this.$apollo.query({
          query: DataServices.getList('voucher', { "fields": `id` }),
          variables: {
            where_key: where_key
          },
          fetchPolicy: "network-only"
        });
        if (data[Object.keys(data)].length > 0) {
          document.getElementById("code").setCustomValidity("Code already exists");
          isFormInvalid = true;
        }
      }
      // kiểm tra start và end, start phải luôn nhỏ hơn end
      console.log('this.obj_data.valid_start:', this.obj_data.valid_start);
      console.log('this.obj_data.valid_end:', this.obj_data.valid_end);       
        // ép kiểu về 1 dạng date moment(params.valid_end, "DD/MM/YYYY").format("YYYY-MM-DD")

      

        

        // if (this.obj_data.type_condition == 2) {
        //   console.log('selectedVehicleCategory:', this.selectedVehicleCategory);

        //   let vehicleCategoryElement = document.getElementById("selectedVehicleCategory");
        //   if (!vehicleCategoryElement) {
        //     console.error("Element with id 'selectedVehicleCategory' not found.");
        //     isFormInvalid = true;
        //   } else if (!Array.isArray(this.selectedVehicleCategory) || this.selectedVehicleCategory.length === 0) {
        //     // Kiểm tra nếu selectedVehicleCategory không phải là mảng hoặc có độ dài bằng 0
        //     vehicleCategoryElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        //     isFormInvalid = true;
        //   } else {
        //     vehicleCategoryElement.setCustomValidity("");
        //   }
        // }



      if (this.obj_data.type_apply_customer == 2) {
        let loyaltyElement = document.getElementById("selectedLoyalty");
        if (!loyaltyElement) {
          console.error("Element with id 'selectedLoyalty' not found.");
          isFormInvalid = true;
        } else if (!Array.isArray(this.selectedLoyalty) || this.selectedLoyalty.length === 0) {
          loyaltyElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
          isFormInvalid = true;
        } else {
          loyaltyElement.setCustomValidity("");
        }
      }

      console.log('vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv', this.listVoucherCustomer);
        
      // Kiểm tra type_apply_customer = 3 và selectedUserAppyVoucher
      // if (this.obj_data.type_apply_customer == 3) {
      //   let userVoucherElement = document.getElementById("selectedUserAppyVoucher");
      //   if (!userVoucherElement) {
      //     console.error("Element with id 'selectedUserAppyVoucher' not found.");
      //     isFormInvalid = true;
      //   } else if (!Array.isArray(this.selectedUserAppyVoucher1) || this.selectedUserAppyVoucher1.length === 0 || this.listVoucherCustomer.length === 0) {
      //     userVoucherElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      //     isFormInvalid = true;
      //   } else {
      //     userVoucherElement.setCustomValidity("");
      //   }
      // }

      // Kiểm tra tính hợp lệ của toàn bộ form
      let inpObj = document.getElementById("frm_action");
      if (!inpObj || !inpObj.checkValidity() || isFormInvalid) {
        if (inpObj) {
          inpObj.reportValidity();
        }
        return true; // Trả về true nếu form không hợp lệ
      }

      return false; // Trả về false nếu form hợp lệ
    },
    formatDateVoucher(dateInput) {
      if (typeof dateInput === 'string' && dateInput.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        const [day, month, year] = dateInput.split('/');
        return new Date(`${month}/${day}/${year}`);
      } else if (dateInput instanceof Date) {
        return dateInput;
      } else {
        return null; 
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      var params = this.obj_data;

      if (params.type_condition == 1 || params.type_condition == 3) {
        params.duration = null;
        params.selectedVehicleCategory = null;
        params.list_category = [];
      } else if (params.type_condition == 2) {
        if (Array.isArray(this.selectedVehicleCategory) && this.selectedVehicleCategory.length > 0) {
          let selectedVehicleIds = this.selectedVehicleCategory.map(item => item.id);
          params.list_category = selectedVehicleIds;
        } else {
          params.list_category = [];
        }
      }

      if (params.type_apply_customer == 1 || params.type_apply_customer == 3) {
        params.list_loyalty = [];
      } else if (params.type_apply_customer == 2) {
        if (Array.isArray(this.selectedLoyalty) && this.selectedLoyalty.length > 0) {
          let selectedLoyalty = this.selectedLoyalty.map(item => item.id);
          params.list_loyalty = selectedLoyalty;
        } else {
          params.list_loyalty = [];
        }
      }

      // Cập nhật selectedUserAppyVoucher
      if (params.type_apply_customer == 1 || params.type_apply_customer == 2) {
        params.list_user_apply_voucher = [];
      } else if (params.type_apply_customer == 3) {
        if (Array.isArray(this.selectedUserAppyVoucher1) && this.selectedUserAppyVoucher1.length > 0) {
          let selectedUserAppyVoucher = this.selectedUserAppyVoucher1.map(item => item.id);
          params.list_user_apply_voucher = selectedUserAppyVoucher;
        } else {
          params.list_user_apply_voucher = [];
        }
      }





      params.duration = this.obj_data?.duration || null;
      params.type_discount = this.selectedtypeDiscount?.id || null;
      params.type_condition = this.obj_data?.type_condition || null;
      params.type_apply_customer = this.obj_data?.type_apply_customer || null;
      params.listDelVehicleCategory = this.listDelVehicleCategory;
      console.log('Paramsssssssssssssss', params);
      this.$emit('save', params); // Lưu dữ liệu hoặc gọi hàm xử lý tiếp theo
    },




    async onActionClicked(payload) {
      console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', payload);
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111" + pageTransaction, payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key], query: { page_transaction: pageTransaction.toString() } })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':

          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
  },
}
</script>

<style lang="scss">
.p-formgrid {
  padding-top: 15px;
}

.main-style-button {
  background: #FFDF01;
}

.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}



.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}


.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}

.p-col-fixed {
  font-weight: 700;
}


// radio Button

.p-radiobutton .p-radiobutton-box {
  position: relative;
  border: 3px solid #666666;
  background-color: #FFFFFF !important;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-left: -1px;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
  box-shadow: none !important;
  appearance: none;
}

.p-radiobutton input:focus,
.p-radiobutton input:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.p-radiobutton-box:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.p-radiobutton .p-radiobutton-box::after {
  content: '';
  width: 12px;
  height: 12px;
  background-color: #FFFFFF;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.p-radiobutton .p-radiobutton-box.p-highlight::after {
  background-color: #FFDF01;
}

.p-radiobutton .p-radiobutton-box.p-highlight {
  border-color: #666666;
  box-shadow: none !important;
}

.p-radiobutton {
  display: block;
}

.p-radiobutton-box.p-highlight.p-focus {
  box-shadow: none !important;
  outline: none !important;
  border-color: #666666 !important;
  background-color: #FFDF01;
}


.p-radiobutton {
  display: block;
  align-items: center;
  margin-right: 8px;
}

.p-radiobutton label {
  margin-left: 8px;
  vertical-align: baseline;
  position: relative;
  top: 2px;
}

.css_voucher1 {
  color: #666666;

  margin-top: 15px;

}

.p-field-checkbox,
.p-field-radiobutton {
  margin-bottom: 0px;
  display: flex;
  align-items: center;
}



.style_title_group_car_infomation {
  position: relative;
  margin-top: 10px;
  margin-bottom: 30px;
}

.style_title_group_car_infomation::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #d3d0d0;
  transform: translateX(-15px);
}

.p-multiselect {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.new-select {
  width: calc(100% - 50px);
}

.p-col-auto {
  width: 50px;
  margin-left: 5px;
}

.selected-items {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.selected-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 20px;
  margin-right: 8px;
  margin-bottom: 8px;
  font-size: 14px;
}

.remove-button {
  background: none;
  border: none;
  color: #333;
  margin-left: 8px;
  font-weight: bold;
  cursor: pointer;
  outline: none;
}

.remove-button:hover {
  color: red;
}


.p-button-outlined .p-button-label {
    color: #000000 !important;
}
</style>
